import React from "react";
import { View, Text, StyleSheet, Dimensions, Platform } from "react-native";
import FontFamily from "../../constants/fonts";

const ContactUsWelcome: React.FC = () => {
  // Helper function to check if device is in mobile layout
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const isMobileView = () => {
    const windowWidth = Dimensions.get("window").width;
    return (
      Platform.OS === "ios" || Platform.OS === "android" || windowWidth < 768
    );
  };

  return (
    <View style={styles.welcomeCard}>
      <View style={styles.welcomeContainer}>
        <View style={styles.welcomeLeftContent}>
          <Text style={styles.welcomeText}>Contact Us/Feedback</Text>
        </View>
      </View>
      <View style={styles.descriptionContainer}>
        <Text style={styles.descriptionText}>
          Share your observations, report issues, or provide feedback on the
          Lighthouse application. Your input helps us improve our services and
          address any concerns.
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  welcomeCard: {
    backgroundColor: "transparent",
    borderRadius: 0,
    borderLeftWidth: 0,
    shadowColor: "transparent",
    elevation: 0,
  },
  welcomeContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
   // padding: 16,
    flexWrap: "nowrap",
  },
  welcomeLeftContent: {
    flexDirection: "row",
    alignItems: "center",
  },
  welcomeText: {
    color: "#3A3A3A",
    // Heading/Bold/$font-heading-h4-bold
    fontSize: 28,
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: 40,
    fontFamily: FontFamily.bold
  },
  descriptionContainer: {
   // paddingHorizontal: 16,
    paddingBottom: 16,
    marginTop: 6,
  },
  descriptionText: {
    color: "#3A3A3A",
    // Small/$font-small-regular
    fontSize: 14,
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: 20,
    fontFamily: FontFamily.regular
  },
});

export default ContactUsWelcome;
